export default class Cover extends Phaser.GameObjects.Sprite {
    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y, 'atlas', 'blank');

        let width = this.scene.cameras.main.width;
        let height = this.scene.cameras.main.height;

        this.setDisplaySize(width, height);
        this.setAlpha(0.01);
        this.setInteractive();

        this.hide();
    }

    show() {
        this.setVisible(true);
    }

    hide() {
        this.setVisible(false);
    }
}
